
import {Button} from "@progress/kendo-react-buttons";
import "./SubscriptionLoginButton.scss";
import React from "react";

interface ISub {
    toggleDialog: () => void;
}

const SubscriptionLoginButton = (props: ISub) => {

    return (
        //  "/rules/login"

        <div>
            <Button className={"signInButton"} fillMode={"link"} onClick={props.toggleDialog}>
                <span className="k-icon k-i-login">&nbsp;</span>Subscriptions Login
            </Button>
        </div>
    );
};

export default SubscriptionLoginButton